<mat-paginator
  [length]="totalItems"
  [pageSize]="pageSize"
  [pageIndex]="page - 1"
  [pageSizeOptions]="pageSizeOptions"
  (page)="onPage($event)">
</mat-paginator>
